/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'languageConversion',
  standalone: true
})
export class languageConversionPipe implements PipeTransform {
  returnVariable: string = '';
  transform(value: any, args?: any): any {

    if (!args || !args[0] || typeof args[0] !== 'object') {
      return value; // Return the original value if args[0] is null/undefined or not an object
    }

    let keys: any = Object.keys(args[0]);

    keys = keys.filter((el: any) => el.includes(args[2]));

    if (args[1] === 'en') {
      keys = keys.filter((el: any) => {
        if (el.includes('_ar')) {
          return false;
        } else {
          return true;
        }
      });
      this.returnVariable = args[0][keys];
    }

    if (args[1] === 'ar') {
      keys = keys.filter((el: any) => {
        if (el.includes('_ar')) {
          return true;
        } else {
          return false;
        }
      });
      this.returnVariable = args[0][keys];
    }
    return this.returnVariable;
  }
}
